import { TextBox } from "component_old/micro/view/TextBox"
import React from "react"
import styled from "styled-components/macro"

interface Props {
  children?: React.ReactNode
  className?: string
}

export const TextBodyContent = (props: Props) => {
  return (
    <S_TextBodyContent className={props.className}>
      <S_Wrap>
        <S_Box>{props.children}</S_Box>
      </S_Wrap>
    </S_TextBodyContent>
  )
}

const S_TextBodyContent = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`

const S_Wrap = styled.div`
  display: flex;
  box-sizing: border-box;
  flex-direction: column;
  padding: 20px 10px;
  justify-content: center;
  @media only screen and (min-width: 1260px) {
    width: 1260px;
    margin: 30px 0 0 0;
  }
`

const S_Box = styled(TextBox)`
  padding: 15px;
  z-index: 1;
  h1,
  h2,
  h3,
  h3 strong {
    font-family: "InterBold";

    margin: 0 0 15px 0;
    letter-spacing: -0.03em;
  }
  h1 {
    font-size: 25px;
  }
  h2,
  h3 {
    font-size: 17px;
  }
  p {
    font-family: "InterRegular";
    font-size: 13px;
    margin: 0 0 15px 0;
    line-height: 22px;
  }
  ul {
    font-family: "InterRegular";
    font-size: 13px;
    margin: 0 0 15px 0;
    line-height: 22px;
    list-style-type: none;
    li {
      padding: 0 0 0px 15px;
      box-sizing: border-box;
    }
  }
  @media only screen and (min-width: 1260px) {
    padding: 30px;
    h1,
    h2,
    h3,
    h3 strong {
      margin: 0 0 30px 0;
    }
    h1 {
      font-size: 30px;
    }
    h2,
    h3 {
      font-size: 22px;
    }
    p {
      font-size: 16px;
      line-height: 28px;
      margin: 0 0 30px 0;
    }
    ul {
      font-size: 16px;
      line-height: 28px;
      margin: 0 0 30px 0;
    }
  }
`
